<template>
  <div class="mine-container">
    <div class="mine-content">
      <div class="mine-sidebar">
        <!-- 用户信息 -->
        <div class="user-info">
          <div class="breadcrumb-section" style="height: 40px">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
              <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="avatar">
            <img src="@/assets/img/mall/avatar.png" alt="avatar" />
          </div>
          <div class="user-name">{{ userInfo.mobile | formatMobile }}</div>
        </div>

        <!-- 侧边栏菜单 -->
        <div class="menu-list">
          <div v-for="menu in menuList" :key="menu.key" :class="['menu-item', activeComponent === menu.component ? 'active' : '']" @click="switchComponent(menu.component)">
            {{ menu.label }}
          </div>
        </div>
      </div>

      <div class="mine-main">
        <component :is="activeComponent"></component>
      </div>
    </div>

    <footer-layout></footer-layout>
  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue'
import FooterLayout from '@/components/pc/FooterLayout.vue'
import { Session } from '@/utils/storage'

// 动态导入子组件
const AccountManage = () => import('./components/mine/AccountManage.vue')
const MyOrder = () => import('./components/mine/MyOrder.vue')
const PreOrder = () => import('./components/mine/PreOrder.vue')
const AfterSale = () => import('./components/mine/AfterSale.vue')
const MyBalance = () => import('./components/mine/MyBalance.vue')
const MyPoints = () => import('./components/mine/MyPoints.vue')
const MyCollection = () => import('./components/mine/MyCollection.vue')
const AddressManage = () => import('./components/mine/AddressManage.vue')
const MyInvoice = () => import('./components/mine/MyInvoice.vue')
const JoinRecord = () => import('./components/mine/JoinRecord.vue')
const MyCoupon = () => import('./components/mine/MyCoupon.vue')

export default {
  name: 'MinePage',
  components: {
    HeaderLayout,
    FooterLayout,
    AccountManage,
    MyOrder,
    PreOrder,
    AfterSale,
    MyBalance,
    MyPoints,
    MyCollection,
    AddressManage,
    MyInvoice,
    JoinRecord,
    MyCoupon
  },
  data() {
    return {
      userInfo: null,
      activeComponent: 'AccountManage',
      menuList: [
        { label: '账户管理', key: 'account', component: 'AccountManage' },
        { label: '我的订单', key: 'order', component: 'MyOrder' },
        // { label: '预售订单', key: 'preOrder', component: 'PreOrder' },
        { label: '售后/退款', key: 'afterSale', component: 'AfterSale' },
        { label: '我的余额', key: 'balance', component: 'MyBalance' },
        { label: '我的积分', key: 'points', component: 'MyPoints' },
        { label: '我的优惠券', key: 'coupon', component: 'MyCoupon' },
        { label: '我的收藏', key: 'collection', component: 'MyCollection' },
        { label: '地址管理', key: 'address', component: 'AddressManage' },
        { label: '我的发票', key: 'invoice', component: 'MyInvoice' }
        // { label: '入驻记录', key: 'joinRecord', component: 'JoinRecord' },
      ]
    }
  },
  created() {
    this.initUserInfo()
  },
  watch: {
    // 监听路由变化
    '$route.query': {
      handler(query) {
        // 根据 query.tab 切换组件
        switch (query.tab) {
          case 'order':
            this.activeComponent = 'MyOrder'
            break
          case 'collection':
            this.activeComponent = 'MyCollection'
            break
          default:
            // 默认显示账户管理
            this.activeComponent = 'AccountManage'
        }
      },
      immediate: true
    }
  },
  methods: {
    initUserInfo() {
      const userInfo = Session.get('userInfo')
      if (userInfo) {
        this.userInfo = userInfo
      } else {
        this.$router.push('/pc/mall')
      }
    },
    switchComponent(component) {
      this.activeComponent = component
    }
  }
}
</script>

<style lang="scss" scoped>
.mine-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;

  .mine-content {
    flex: 1;
    width: 1200px;
    margin: 20px auto;
    display: flex;
    gap: 20px;

    .mine-sidebar {
      width: 240px;
      background-color: #fff;
      border-radius: 4px;
      padding: 20px 0;

      .user-info {
        padding: 0 20px;
        margin-bottom: 20px;
        text-align: center;

        .avatar {
          width: 80px;
          height: 80px;
          margin: 0 auto 10px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .user-name {
          font-size: 16px;
          color: #333;
        }
      }

      .menu-list {
        .menu-item {
          padding: 14px 20px;
          cursor: pointer;
          color: #666;
          font-size: 14px;

          &:hover {
            color: #409eff;
            background-color: #ecf5ff;
          }

          &.active {
            color: #409eff;
            background-color: #ecf5ff;
            border-right: 2px solid #409eff;
          }
        }
      }
    }

    .mine-main {
      flex: 1;
      background-color: #fff;
      border-radius: 4px;
      padding: 20px;
    }
  }
}
</style>
